export const fetchWithRetry = async <T>(promiseFn: () => Promise<T>, retries: number = 3): Promise<T> => {
  try {
    return await promiseFn()
  } catch (error) {
    return retries > 0
      ? await fetchWithRetry(promiseFn, retries - 1)
      : await Promise.reject(error)
  }
}
